module.exports = __webpack_public_path__ + "img/product-smoke-22.e4b114c7.jpg";